export interface EmailData {
  email: string;
  firstName: string;
  lastName: string;
}

export interface UserInput {
  username: string;
  firstName: string;
  lastName: string;
}

const buildEmailUsers = (
  sender: UserInput,
  recipient: UserInput
): {
  recipient: EmailData;
  sender: EmailData;
} => ({
  recipient: {
    email: recipient.username,
    firstName: recipient.firstName,
    lastName: recipient.lastName
  },
  sender: { email: sender.username, firstName: sender.firstName, lastName: sender.lastName }
});

export default buildEmailUsers;
